import { RawScoreDataPoint, Trend } from '../models/score';

export const getValidScores = (
  scores?: RawScoreDataPoint[],
  scoreKey: 'ayble_score' | 'stress_score' = 'ayble_score'
) => {
  return (
    scores?.flatMap((s) => {
      // Assign to a local so TS narrows the dynamic indexed access
      // (`s[scoreKey]`) to `number` inside the guard — without this the
      // flatMap infers `(number | undefined)[]`.
      const value = s[scoreKey];
      return value != null ? [value] : [];
    }) ?? []
  );
};

export const computeOverTimeScore = (scores?: RawScoreDataPoint[]) => {
  const validAybleScores = getValidScores(scores);

  return validAybleScores.length
    ? validAybleScores.reduce((sum, score) => sum + score, 0) /
        validAybleScores.length
    : 0;
};

export const formatScore = (score: number): number => {
  return parseFloat((score * 10).toFixed(1));
};

export const formatScoreString = (score: number): string => {
  return (score * 10).toFixed(1);
};

export const computeScoreTrend = (
  overTimeScore: number,
  todayScore: number
) => {
  return overTimeScore >= todayScore ? Trend.down : Trend.up;
};

export const computeTodayScore = (scores?: RawScoreDataPoint[]) => {
  return scores?.[0]?.ayble_score ?? 0;
};

const defaultAybleScores = {
  ayble_score: [],
  stress_score: [],
  over_time_score: '0',
  today_score: '0',
  rawData: [],
};

export const computeAybleScores = (scores?: RawScoreDataPoint[]) => {
  return scores
    ? {
        ayble_score: getValidScores(scores)?.map((score) =>
          formatScoreString(score)
        ),
        stress_score: getValidScores(scores, 'stress_score')?.map((score) =>
          formatScoreString(score)
        ),
        over_time_score: formatScoreString(computeOverTimeScore(scores)),
        today_score: formatScoreString(computeTodayScore(scores)),
        rawData: scores,
      }
    : defaultAybleScores;
};
